<template>
    <div>
        <div class="text-xs-right">
            <v-layout justify-end align-center class="button-group">
                <!-- Bouton Transfer Money -->
                <v-menu offset-y transition="slide-y-transition" origin="top right">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="white--text elevation-4 transfer-btn"
                            small
                            rounded
                            color="purple darken-2"
                            v-on="on"
                        >
                            <v-icon left small>fas fa-exchange-alt</v-icon>
                            <span>Transfer</span>
                            <v-icon right x-small>fas fa-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-card class="elevation-12 menu-card" width="200">
                        <v-list dense class="py-0 menu-list">
                            <v-list-item
                                @click="goToRoute('savings.money_transfer.send')"
                                ripple
                                class="menu-item send-item"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="teal darken-3" class="fas fa-paper-plane"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="teal--text text--darken-3 font-weight-medium body-2">
                                    Send Money
                                </v-list-item-title>
                            </v-list-item>

                            <v-divider class="my-0 menu-divider"></v-divider>

                            <v-list-item
                                @click="goToRoute('savings.money_transfer.sent_history')"
                                ripple
                                class="menu-item receive-item"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="purple darken-3" class="fas fa-clock-rotate-left"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="purple--text text--darken-3 font-weight-medium body-2">
                                    Sent History
                                </v-list-item-title>
                            </v-list-item>

                            <v-divider class="my-0 menu-divider"></v-divider>

                            <v-list-item
                                @click="goToRoute('savings.money_transfer.received_history')"
                                ripple
                                class="menu-item receive-item"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="blue darken-3" class="fas fa-history"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="blue--text text--darken-3 font-weight-medium body-2">
                                    Receive History
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>

                <!-- Bouton New Campaign avec Dialog -->
                <div v-if="$store.state.lengthActiveCampaigns2 < 2" class="mr-2">
                    <v-btn
                        class="white--text elevation-4"
                        small
                        rounded
                        color="teal darken-2"
                        style="min-width: 140px; border-radius: 24px;"
                        @click="openProductSelectionDialog"
                    >
                        <v-icon left small class="fas fa-plus"></v-icon>
                        <span>New Campaign</span>
                    </v-btn>
                </div>
                <div v-else class="mr-2">
                    <v-btn
                        class="white--text elevation-4"
                        small
                        rounded
                        color="teal darken-2"
                        @click="completeActiveCampaignMsg()"
                        style="min-width: 140px; border-radius: 24px;"
                    >
                        <span>New Campaign</span>
                    </v-btn>
                </div>
            </v-layout>
        </div>

        <!-- RESTE DU CODE CAMPAGNES EXISTANT -->
        <div v-if="campaigns.length === 0">
            <h1>No {{$route.params.category}} campaigns exists yet</h1>
        </div>

        <!-- BARRE CURRENT ACCOUNT -->
        <v-card class="elevation-4 mt-2" style="border-radius: 10px" v-for="item in campaigns" :key="item.key">
            <v-layout row wrap text-xs-center v-if="item.principal">
                <h2 class="pa-2 dark--text text-xs-left"><span class="blue--text">Current Account:</span> {{item.saved_amount}} FCFA</h2>
            </v-layout>
        </v-card>

        <!-- AFFICHAGE POUR CAMPAGNES ACTIVES MARKETPLACE -->
        <div v-if="$route.params.category === 'active'" class="mt-3 pa-0" style="max-height: 400px; overflow: auto">
            <!-- Marketplace Campaigns -->
            <div v-for="campaign in marketplaceActiveCampaigns" :key="campaign.id">
                <v-card class="elevation-4 mb-3" style="border-radius: 12px; cursor: pointer;"
                    @click="$router.push('/market_place/campaign/detail/'+campaign.id)">
                    <v-card-text class="px-3 py-2" style="font-size: 12px;">
                        <!-- En-tête de la campagne -->
                        <v-layout row wrap align-center class="mb-1">
                            <v-flex xs8>
                                <h2 :class="titleColor">Campaign: {{campaign.name}}</h2>
                            </v-flex>
                            <v-flex xs4 class="text-xs-right">
                                <v-chip small color="teal" text-color="white">
                                    Active
                                </v-chip>
                            </v-flex>
                        </v-layout>

                        <!-- Informations de base -->
                        <span><b>Creation Date:</b> {{campaign.get_date_str}}</span>
                        <v-spacer></v-spacer>
                        <div v-if="campaign.target_amount && campaign.target_date" >
                            <span><b>Objective:</b> Reach {{campaign.target_amount}} FCFA By the {{campaign.target_date}} </span>
                        </div>
                        <div v-else-if="campaign.target_amount" >
                            <span><b>Objective:</b> Reach {{campaign.target_amount}} FCFA </span>
                        </div>
                        <div v-else-if="campaign.target_date" >
                            <span><b>Objective:</b> On the {{campaign.target_date}} </span>
                        </div>

                        <!-- Point de livraison pour les campagnes market -->
                        <div v-if="campaign.market_item && campaign.shipping_point" class="mt-1 mb-1">
                            <v-icon small color="teal" class="mr-1">local_shipping</v-icon>
                            <span class="caption teal--text text--darken-2">
                                <b>Delivery Point:</b> {{campaign.shipping_point}}
                            </span>
                        </div>


                        <!-- Barre de progression -->
                        <div class="mt-2">
                            <v-progress-linear
                                :value="parseFloat(campaign.percentage_completed.replace('%', ''))"
                                height="8"
                                color="teal"
                                rounded
                                class="mb-1"
                            ></v-progress-linear>
                            <div class="caption grey--text">
                                Progress: {{campaign.saved_amount}} / {{campaign.target_amount}} FCFA ({{campaign.percentage_completed}})
                            </div>
                        </div>

                        <!-- Section Éligibilité (chargée dynamiquement) -->
                        <div v-if="loadingEligibility[campaign.id]" class="text-center py-2 mt-2">
                            <v-progress-circular
                                indeterminate
                                size="20"
                                color="teal"
                            ></v-progress-circular>
                            <div class="caption grey--text mt-1">Checking eligibility...</div>
                        </div>

                        <div v-else-if="eligibilityData[campaign.id]" class="mt-2">
                            <!-- Information de livraison existante -->
                            <div v-if="eligibilityData[campaign.id].has_delivery ||
                                      (campaignDeliveries[campaign.id] && campaignDeliveries[campaign.id].has_delivery)"
                                 class="mb-3">
                                <v-alert dense text type="info" class="py-1 mb-2">
                                    <div class="d-flex align-center">
                                        <v-icon x-small color="info" class="mr-1">mdi-package-check</v-icon>
                                        <span class="caption">
                                            <span v-if="eligibilityData[campaign.id].has_delivery">
                                                Item delivered at {{ eligibilityData[campaign.id].percentage_at_delivery }}%
                                                ({{ formatDate(eligibilityData[campaign.id].delivery_date) }})
                                            </span>
                                            <span v-else-if="campaignDeliveries[campaign.id]">
                                                Item delivered at {{ campaignDeliveries[campaign.id].percentage_at_delivery }}%
                                                ({{ formatDate(campaignDeliveries[campaign.id].delivery_date) }})
                                            </span>
                                        </span>
                                    </div>
                                </v-alert>
                                <div class="caption grey--text text-center">
                                    <v-icon x-small color="grey" class="mr-1">mdi-information</v-icon>
                                    Continue saving until 100% to complete your campaign
                                </div>
                            </div>

                            <!-- Indicateur d'éligibilité (uniquement si non livré) -->
                            <div v-if="!eligibilityData[campaign.id].has_delivery &&
                                      !(campaignDeliveries[campaign.id] && campaignDeliveries[campaign.id].has_delivery)"
                                 class="mb-3">
                                <!-- Éligible pour livraison à 50% -->
                                <div v-if="eligibilityData[campaign.id].is_eligible" class="d-flex align-center mb-2">
                                    <v-tooltip top max-width="300">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="d-flex align-center eligibility-badge" v-bind="attrs" v-on="on">
                                                <v-icon small color="success" class="mr-2">mdi-check-decagram</v-icon>
                                                <span class="caption success--text font-weight-bold">Eligible for 50% Delivery</span>
                                                <v-icon small color="grey lighten-1" class="ml-1">mdi-information</v-icon>
                                            </div>
                                        </template>
                                        <div class="pa-2">
                                            <div class="font-weight-bold mb-1">Why you're eligible:</div>
                                            <ul class="ma-0 pl-3">
                                                <li>✓ Special account status (payment + business)</li>
                                                <li>✓ Reached minimum 50% of target ({{ campaign.saved_amount.toLocaleString() }} / {{ campaign.target_amount.toLocaleString() }} FCFA)</li>
                                                <li>✓ Sufficient credit points ({{ eligibilityData[campaign.id].user_credit_points }}/{{ eligibilityData[campaign.id].required_credit }})</li>
                                            </ul>
                                            <div class="caption mt-2">
                                                You can request delivery now or continue to 100%.
                                            </div>
                                        </div>
                                    </v-tooltip>
                                </div>

                                <!-- Pas encore éligible mais avec statut spécial -->
                                <div v-else-if="eligibilityData[campaign.id].has_special_status &&
                                                campaign.saved_amount < campaign.target_amount * 0.5"
                                     class="d-flex align-center mb-2">
                                    <v-tooltip top max-width="300">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="d-flex align-center" v-bind="attrs" v-on="on">
                                                <v-icon small color="warning" class="mr-2">mdi-progress-clock</v-icon>
                                                <span class="caption warning--text">Eligible at 50% (special account)</span>
                                                <v-icon small color="grey lighten-1" class="ml-1">mdi-information</v-icon>
                                            </div>
                                        </template>
                                        <div class="pa-2">
                                            <div class="font-weight-bold mb-1">Requirements for 50% delivery:</div>
                                            <ul class="ma-0 pl-3">
                                                <li>✓ Special account status (payment + business) ✓</li>
                                                <li>◯ Reach 50% of target: {{ campaign.saved_amount.toLocaleString() }} / {{ (campaign.target_amount * 0.5).toLocaleString() }} FCFA</li>
                                                <li>◯ Credit points: {{ eligibilityData[campaign.id].user_credit_points }}/{{ eligibilityData[campaign.id].required_credit }}</li>
                                            </ul>
                                            <div class="caption mt-2">
                                                Need {{ Math.ceil(campaign.target_amount * 0.5 - campaign.saved_amount).toLocaleString() }} FCFA more to reach 50%.
                                            </div>
                                        </div>
                                    </v-tooltip>
                                </div>

                                <!-- Pas de statut spécial -->
                                <div v-else-if="!eligibilityData[campaign.id].has_special_status &&
                                                campaign.saved_amount < campaign.target_amount"
                                     class="d-flex align-center mb-2">
                                    <v-tooltip top max-width="300">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="d-flex align-center" v-bind="attrs" v-on="on">
                                                <v-icon small color="info" class="mr-2">mdi-information</v-icon>
                                                <span class="caption info--text">Standard account - 100% required</span>
                                                <v-icon small color="grey lighten-1" class="ml-1">mdi-information</v-icon>
                                            </div>
                                        </template>
                                        <div class="pa-2">
                                            <div class="font-weight-bold mb-1">Delivery requirements:</div>
                                            <ul class="ma-0 pl-3">
                                                <li>◯ Standard account (no special status)</li>
                                                <li>◯ Must reach 100% of target: {{ campaign.saved_amount.toLocaleString() }} / {{ campaign.target_amount.toLocaleString() }} FCFA</li>
                                                <li>◯ Contact support to upgrade to special account</li>
                                            </ul>
                                            <div class="caption mt-2">
                                                Need {{ Math.ceil(campaign.target_amount - campaign.saved_amount).toLocaleString() }} FCFA more to reach 100%.
                                            </div>
                                        </div>
                                    </v-tooltip>
                                </div>

                                <!-- Manque de crédit -->
                                <div v-else-if="eligibilityData[campaign.id].has_special_status &&
                                                campaign.saved_amount >= campaign.target_amount * 0.5 &&
                                                eligibilityData[campaign.id].user_credit_points < eligibilityData[campaign.id].required_credit"
                                     class="d-flex align-center mb-2">
                                    <v-tooltip top max-width="300">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="d-flex align-center" v-bind="attrs" v-on="on">
                                                <v-icon small color="warning" class="mr-2">mdi-medal</v-icon>
                                                <span class="caption warning--text">Insufficient credit points</span>
                                                <v-icon small color="grey lighten-1" class="ml-1">mdi-information</v-icon>
                                            </div>
                                        </template>
                                        <div class="pa-2">
                                            <div class="font-weight-bold mb-1">Credit requirement:</div>
                                            <ul class="ma-0 pl-3">
                                                <li>✓ Special account status ✓</li>
                                                <li>✓ 50% progress reached ✓</li>
                                                <li>◯ Credit points: {{ eligibilityData[campaign.id].user_credit_points }}/{{ eligibilityData[campaign.id].required_credit }}</li>
                                            </ul>
                                            <div class="caption mt-2">
                                                Need {{ eligibilityData[campaign.id].required_credit - eligibilityData[campaign.id].user_credit_points }} more credit points.
                                                Earn credits by participating in platform activities.
                                            </div>
                                        </div>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>

                        <!-- Boutons d'action -->
                        <v-layout row wrap justify-end class="mt-2">
                            <!-- Bouton WhatsApp (visible uniquement pour les comptes éligibles à partir de 50% OU pour toutes les campagnes completed) -->
                            <v-btn
                                v-if="shouldShowChatButtons(campaign)"
                                small
                                rounded
                                color="#25D366"
                                class="white--text mr-1 action-btn whatsapp-btn"
                                @click.stop="openWhatsApp(campaign)"
                            >
                                <v-icon left small>fab fa-whatsapp</v-icon>
                                WhatsApp
                            </v-btn>

                            <!-- Bouton Chat Support (mêmes conditions) -->
                            <v-btn
                                v-if="shouldShowChatButtons(campaign)"
                                small
                                rounded
                                color="teal darken-2"
                                class="white--text action-btn chat-btn"
                                @click.stop="openPettyCashChat(campaign)"
                            >
                                <v-icon left small>fas fa-comments</v-icon>
                                Chat Support
                            </v-btn>

                            <!-- Icône de demande de livraison (uniquement si éligible et non livré) -->
                            <v-tooltip top v-if="eligibilityData[campaign.id] &&
                                                 eligibilityData[campaign.id].is_eligible &&
                                                 !eligibilityData[campaign.id].has_delivery &&
                                                 !(campaignDeliveries[campaign.id] && campaignDeliveries[campaign.id].has_delivery)">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        small
                                        color="success"
                                        class="ml-2 delivery-icon-btn"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="requestDelivery(campaign)"
                                    >
                                        <v-icon small>mdi-truck-delivery</v-icon>
                                    </v-btn>
                                </template>
                                <span>Request delivery (eligible at 50%)</span>
                            </v-tooltip>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </div>

            <!-- Campagnes actives non-marketplace (afficher normalement) -->
            <v-hover v-for="campaign in nonMarketplaceActiveCampaigns" :key="campaign.id">
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 18 : 4}`" color="white" style="margin-bottom: 8px;"
                    :to="'/savings/campaigns/detail/'+campaign.id"
                >
                    <v-card-text class="px-3 py-2" style="font-size: 12px; cursor: pointer">
                        <h2 :class="titleColor">Campaign: {{campaign.name}}<blink v-if="campaign.notification" class="pt-0 mt-0" style="font-size: 8px; position: relative; top: 0"><i class="red--text fas fa-circle"></i></blink></h2>
                        <span><b>Creation Date:</b> {{campaign.get_date_str}}</span>
                        <v-spacer></v-spacer>
                        <div v-if="campaign.target_amount && campaign.target_date" >
                            <span><b>Objective:</b> Reach {{campaign.target_amount}} FCFA By the {{campaign.target_date}} </span>
                        </div>
                        <div v-else-if="campaign.target_amount" >
                            <span><b>Objective:</b> Reach {{campaign.target_amount}} FCFA </span>
                        </div>
                        <div v-else-if="campaign.target_date" >
                            <span><b>Objective:</b> On the {{campaign.target_date}} </span>
                        </div>

                        <!-- Point de livraison pour les campagnes market (autres catégories) -->
                        <div v-if="campaign.market_item && campaign.shipping_point" class="mt-1">
                            <v-icon small color="teal" class="mr-1">local_shipping</v-icon>
                            <span class="caption teal--text text--darken-2">
                                <b>Delivery Point:</b> {{campaign.shipping_point}}
                            </span>
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </v-hover>
        </div>

        <!-- AFFICHAGE POUR COMPLETED AVEC SÉPARATION NEW/OLD -->
        <div v-if="$route.params.category === 'completed'" class="mt-3 pa-0" style="max-height: 400px; overflow: auto">

            <!-- SECTION NEW SYSTEM -->
            <div v-if="newSystemCampaigns.length > 0">
                <!-- Titre et explication -->
                <v-card class="elevation-2 mb-3" style="border-radius: 10px; background: #e3f2fd;">
                    <v-card-text class="pa-3">
                        <h3 class="teal--text mb-1">🆕 New System Campaigns</h3>
                        <p class="caption grey--text mb-0">
                            These campaigns use the new completion system with enhanced tracking and withdrawal management.
                        </p>
                    </v-card-text>
                </v-card>

                <!-- Campagnes new system -->
                <v-hover v-for="item in newSystemCampaigns" :key="item.id">
                    <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 18 : 4}`" color="white" style="margin-bottom: 8px;">
                        <v-card-text class="px-3 py-2" style="font-size: 12px;">
                            <v-layout row wrap align-center class="mb-1">
                                <v-flex xs8>
                                    <h2 :class="titleColor" style="cursor: pointer;"
                                         @click="$router.push('/savings/campaigns/detail/'+item.id)">
                                        Campaign: {{item.name}}
                                    </h2>
                                </v-flex>
                                <v-flex xs4 class="text-xs-right">
                                    <v-chip x-small color="teal" text-color="white" class="mr-1">
                                        NEW
                                    </v-chip>
                                    <v-chip v-if="item.completed_status === 'withdrawn'" x-small color="green" text-color="white">
                                        WITHDRAWN
                                    </v-chip>
                                    <v-chip v-else x-small color="orange" text-color="white">
                                        PENDING
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <span><b>Creation Date:</b> {{item.get_date_str}}</span>
                            <v-spacer></v-spacer>
                            <div v-if="item.target_amount && item.target_date" >
                                <span><b>Objective:</b> Reach {{item.target_amount}} FCFA By the {{item.target_date}} </span>
                            </div>
                            <div v-else-if="item.target_amount" >
                                <span><b>Objective:</b> Reach {{item.target_amount}} FCFA </span>
                            </div>
                            <div v-else-if="item.target_date" >
                                <span><b>Objective:</b> On the {{item.target_date}} </span>
                            </div>

                            <!-- NOUVEAU : Afficher le point de livraison pour les campagnes market -->
                            <div v-if="item.market_item && item.shipping_point" class="mt-1 mb-1">
                                <v-icon small color="teal" class="mr-1">local_shipping</v-icon>
                                <span class="caption teal--text text--darken-2">
                                    <b>Delivery Point:</b> {{item.shipping_point}}
                                </span>
                            </div>
                            <div v-else-if="item.market_item" class="mt-1 mb-1">
                                <v-icon small color="grey" class="mr-1">local_shipping</v-icon>
                                <span class="caption grey--text">
                                    <b>Delivery Point:</b> Not specified
                                </span>
                            </div>

                            <!-- PROGRESSION POUR NEW SYSTEM -->
                            <div class="mt-2">
                                <v-progress-linear
                                    :value="(item.saved_amount / item.target_amount) * 100"
                                    height="8"
                                    color="blue"
                                    class="mb-1"
                                ></v-progress-linear>
                                <div class="caption grey--text">
                                    Progress: {{item.saved_amount}} / {{item.target_amount}} FCFA ({{item.percentage_completed}})
                                </div>
                            </div>

                            <!-- BOUTONS D'ACTION POUR LES CAMPAGNES NON WITHDRAWN -->
                            <!-- Pour les campagnes completed, afficher les boutons chat seulement si pas encore livré -->
                            <v-layout v-if="item.completed_status === 'pending'" row wrap justify-end class="mt-2">
                                <v-btn
                                    v-if="!item.delivered || item.saved_amount < item.target_amount"
                                    small
                                    rounded
                                    color="#25D366"
                                    class="white--text mr-2 action-btn whatsapp-btn"
                                    @click.stop="openWhatsApp(item)"
                                >
                                    <v-icon left small>fab fa-whatsapp</v-icon>
                                    WhatsApp
                                </v-btn>

                                <v-btn
                                    v-if="!item.delivered || item.saved_amount < item.target_amount"
                                    small
                                    rounded
                                    color="teal darken-2"
                                    class="white--text action-btn chat-btn"
                                    @click.stop="openPettyCashChat(item)"
                                >
                                    <v-icon left small>fas fa-comments</v-icon>
                                    Chat Support
                                </v-btn>
                            </v-layout>

                            <!-- MESSAGE POUR LES CAMPAGNES DÉJÀ WITHDRAWN -->
                            <v-alert v-else type="success" dense class="mt-2 mb-0">
                                <v-icon small left>fas fa-check-circle</v-icon>
                                Funds successfully withdrawn
                            </v-alert>
                        </v-card-text>
                        <v-divider></v-divider>
                    </v-card>
                </v-hover>
            </div>

            <!-- SÉPARATEUR -->
            <v-divider class="my-4" v-if="newSystemCampaigns.length > 0 && oldSystemCampaigns.length > 0"></v-divider>

            <!-- SECTION OLD SYSTEM -->
            <div v-if="oldSystemCampaigns.length > 0">
                <!-- Campagnes old system -->
                <v-hover v-for="item in oldSystemCampaigns" :key="item.id">
                    <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 18 : 4}`" color="white" style="margin-bottom: 8px;"
                        :to="'/savings/campaigns/detail/'+item.id"
                    >
                        <v-card-text class="px-3 py-2" style="font-size: 12px; cursor: pointer">
                            <v-layout row wrap align-center class="mb-1">
                                <v-flex xs12>
                                    <h2 :class="titleColor">Campaign: {{item.name}}</h2>
                                </v-flex>
                            </v-layout>

                            <span><b>Creation Date:</b> {{item.get_date_str}}</span>
                            <v-spacer></v-spacer>
                            <div v-if="item.target_amount && item.target_date" >
                                <span><b>Objective:</b> Reach {{item.target_amount}} FCFA By the {{item.target_date}} </span>
                            </div>
                            <div v-else-if="item.target_amount" >
                                <span><b>Objective:</b> Reach {{item.target_amount}} FCFA </span>
                            </div>
                            <div v-else-if="item.target_date" >
                                <span><b>Objective:</b> On the {{item.target_date}} </span>
                            </div>

                            <!-- NOUVEAU : Afficher le point de livraison pour les campagnes market (ancien système) -->
                            <div v-if="item.market_item && item.shipping_point" class="mt-1 mb-1">
                                <v-icon small color="teal" class="mr-1">local_shipping</v-icon>
                                <span class="caption teal--text text--darken-2">
                                    <b>Delivery Point:</b> {{item.shipping_point}}
                                </span>
                            </div>

                            <!-- STATUT POUR OLD SYSTEM -->
                            <div class="mt-1">
                                <v-chip v-if="item.completed_status === 'withdrawn'" x-small color="green" text-color="white">
                                    WITHDRAWN
                                </v-chip>
                                <v-chip v-else x-small color="orange" text-color="white">
                                    PENDING
                                </v-chip>
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                    </v-card>
                </v-hover>
            </div>
        </div>

        <!-- AFFICHAGE NORMAL POUR LES AUTRES CATÉGORIES -->
        <div v-else-if="$route.params.category !== 'active' && $route.params.category !== 'completed'" class="mt-3 pa-0" style="max-height: 400px; overflow: auto">
            <v-hover v-for="item in campaigns" :key="item.id">
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 18 : 4}`" color="white" style="margin-bottom: 8px;"
                    :key="item.key"
                    :to="'/savings/campaigns/detail/'+item.id"
                >
                    <v-card-text class="px-3 py-2" v-if="!item.principal && !item.marketer" style="font-size: 12px; cursor: pointer">
                        <h2 :class="titleColor">Campaign: {{item.name}}<blink v-if="item.notification" class="pt-0 mt-0" style="font-size: 8px; position: relative; top: 0"><i class="red--text fas fa-circle"></i></blink></h2>
                        <span><b>Creation Date:</b> {{item.get_date_str}}</span>
                        <v-spacer></v-spacer>
                        <div v-if="item.target_amount && item.target_date" >
                            <span><b>Objective:</b> Reach {{item.target_amount}} FCFA By the {{item.target_date}} </span>
                        </div>
                        <div v-else-if="item.target_amount" >
                            <span><b>Objective:</b> Reach {{item.target_amount}} FCFA </span>
                        </div>
                        <div v-else-if="item.target_date" >
                            <span><b>Objective:</b> On the {{item.target_date}} </span>
                        </div>

                        <!-- NOUVEAU : Afficher le point de livraison pour les campagnes market (autres catégories) -->
                        <div v-if="item.market_item && item.shipping_point" class="mt-1">
                            <v-icon small color="teal" class="mr-1">local_shipping</v-icon>
                            <span class="caption teal--text text--darken-2">
                                <b>Delivery Point:</b> {{item.shipping_point}}
                            </span>
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </v-hover>
        </div>

        <!-- Dialog de sélection de produit -->
        <v-dialog v-model="productSelectionDialog" max-width="1200px" scrollable persistent>
            <v-card style="border-radius: 16px; overflow: hidden;">
                <v-card-title class="teal darken-2 white--text pa-4" style="background: linear-gradient(135deg, #00897B 0%, #00695C 100%);">
                    <v-icon left color="white" size="32">shopping_basket</v-icon>
                    <span class="headline font-weight-bold">Select a Product to Save For</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeProductDialog" large>
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-4" style="max-height: 700px; background: #f5f5f5;">
                    <!-- Message d'information stylisé -->
                    <v-alert
                        type="info"
                        color="blue darken-1"
                        icon="savings"
                        class="mb-4 elevation-2"
                        dense
                        prominent
                        style="border-radius: 12px;"
                    >
                        <div class="font-weight-bold">💰 Smart Savings Campaign</div>
                        <div class="caption mt-1">Choose a product and we'll automatically create a personalized savings plan to help you buy it!</div>
                    </v-alert>

                    <!-- Filtres et recherche -->
                    <v-card class="mb-4 pa-3 elevation-2" style="border-radius: 12px; background: white;">
                        <v-layout row wrap align-center>
                            <v-flex xs12 sm6 md6 class="pr-2">
                                <v-select
                                    @change="getDialogProducts()"
                                    class="pt-0 mt-0"
                                    color="teal"
                                    v-model="dialogProductCategory"
                                    item-text="name"
                                    dense
                                    item-value="id"
                                    :items="productCategories"
                                    label="Filter by Category"
                                    prepend-inner-icon="filter_list"
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-flex>

                            <v-flex xs10 sm5 md5 class="pl-1">
                                <v-text-field
                                    v-model="dialogSearch"
                                    class="pt-0 mt-0"
                                    label="Search products..."
                                    dense
                                    clearable
                                    prepend-inner-icon="search"
                                    outlined
                                    hide-details
                                    @keyup.enter="searchDialogProducts()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 sm1 md1 class="pl-2">
                                <v-btn fab small color="teal darken-2" @click="searchDialogProducts()" class="elevation-4">
                                    <v-icon small class="white--text">search</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card>

                    <!-- Loader -->
                    <div v-if="loadingProducts" class="text-xs-center pa-5">
                        <v-progress-circular
                            indeterminate
                            color="teal darken-2"
                            :size="60"
                            :width="5"
                        ></v-progress-circular>
                        <p class="mt-4 title grey--text">Loading amazing products...</p>
                    </div>

                    <!-- Grille de produits (comme dans votre template items) -->
                    <v-layout row wrap v-else-if="dialogProducts.length > 0">
                        <v-flex
                            xs12
                            sm6
                            md4
                            lg3
                            v-for="product in dialogProducts"
                            :key="product.id"
                            class="pa-2"
                        >
                            <v-hover>
                                <v-card
                                    slot-scope="{ hover }"
                                    :class="[
                                        `elevation-${hover ? 12 : 2}`,
                                        { 'selected-product-card': selectedProduct && selectedProduct.id === product.id }
                                    ]"
                                    @click="selectProduct(product)"
                                    style="border-radius: 12px; height: 100%; cursor: pointer; overflow: hidden; transition: all 0.3s ease;"
                                >
                                    <v-container fluid class="pa-0">
                                        <v-layout column class="ma-0 pa-0">
                                            <!-- Section image -->
                                            <v-flex class="pa-0 ma-0">
                                                <div class="media-container" style="position: relative; width: 100%; height: 260px; background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%); overflow: hidden;">
                                                    <!-- Vidéo -->
                                                    <video
                                                        v-if="isVideo(product.get_image)"
                                                        :src="product.get_image"
                                                        style="width: 100%; height: 100%; object-fit: cover;"
                                                        muted
                                                    >
                                                    </video>

                                                    <!-- Image -->
                                                    <v-img
                                                        v-else
                                                        :src="product.get_image"
                                                        height="260px"
                                                        width="100%"
                                                        style="transition: transform 0.4s ease;"
                                                        :style="hover ? 'transform: scale(1.1)' : ''"
                                                        cover
                                                    >
                                                        <template v-slot:placeholder>
                                                            <v-layout fill-height align-center justify-center ma-0>
                                                                <v-progress-circular indeterminate color="teal"></v-progress-circular>
                                                            </v-layout>
                                                        </template>
                                                    </v-img>

                                                    <!-- Badge "In Stock" -->
                                                    <div v-if="product.quantity > 0" style="position: absolute; top: 12px; right: 12px; background: rgba(76, 175, 80, 0.95); color: white; padding: 6px 12px; border-radius: 20px; font-size: 11px; font-weight: bold; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
                                                        <v-icon small color="white" style="font-size: 14px;">check_circle</v-icon>
                                                        In Stock: {{ product.quantity }}
                                                    </div>

                                                    <!-- Badge "Out of Stock" -->
                                                    <div v-else style="position: absolute; top: 12px; right: 12px; background: rgba(244, 67, 54, 0.95); color: white; padding: 6px 12px; border-radius: 20px; font-size: 11px; font-weight: bold; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
                                                        <v-icon small color="white" style="font-size: 14px;">warning</v-icon>
                                                        Out of Stock
                                                    </div>

                                                    <!-- Overlay sélection -->
                                                    <div
                                                        v-if="selectedProduct && selectedProduct.id === product.id"
                                                        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 137, 123, 0.85); display: flex; flex-direction: column; align-items: center; justify-content: center; animation: fadeIn 0.3s ease;"
                                                    >
                                                        <v-icon size="72" color="white" style="animation: scaleIn 0.3s ease;">check_circle</v-icon>
                                                        <div class="white--text mt-3 font-weight-bold" style="font-size: 18px; text-shadow: 0 2px 4px rgba(0,0,0,0.3);">SELECTED</div>
                                                    </div>

                                                    <!-- Hover overlay subtil -->
                                                    <div
                                                        v-if="!isVideo(product.get_image) && hover && !(selectedProduct && selectedProduct.id === product.id)"
                                                        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.1); display: flex; align-items: center; justify-content: center; transition: all 0.3s;"
                                                    >
                                                        <v-icon size="48" color="white" style="text-shadow: 0 2px 4px rgba(0,0,0,0.5);">touch_app</v-icon>
                                                    </div>
                                                </div>
                                            </v-flex>

                                            <!-- Informations produit -->
                                            <v-flex class="ma-0 pa-3 text-xs-left" style="width: 100%; background: white;">
                                                <div>
                                                    <div class="title ma-0 pa-0 text-xs-left mb-2" style="font-size: 16px; line-height: 1.3;">
                                                        <strong>{{ product.name | truncate(30, '...') }}</strong>
                                                    </div>

                                                    <v-chip small color="blue lighten-5" text-color="blue darken-3" class="mb-2">
                                                        <v-icon x-small left>category</v-icon>
                                                        {{ product.category }}
                                                    </v-chip>

                                                    <div class="mb-2">
                                                        <div class="caption grey--text mb-1">Description:</div>
                                                        <div class="body-2" style="line-height: 1.4;">
                                                            {{ getCleanDescription(product.description, 70) }}
                                                        </div>
                                                    </div>

                                                    <v-divider class="my-2"></v-divider>

                                                    <v-layout row wrap align-center>
                                                        <v-flex xs12 class="mb-2">
                                                            <div class="text-xs-center pa-2" style="background: linear-gradient(135deg, #00897B 0%, #00695C 100%); border-radius: 8px;">
                                                                <div class="caption white--text mb-1" style="opacity: 0.9;">Price</div>
                                                                <div class="title white--text font-weight-bold" style="font-size: 22px;">
                                                                    {{ product.price }} FCFA
                                                                </div>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-hover>
                        </v-flex>
                    </v-layout>

                    <!-- Aucun produit -->
                    <div v-else class="text-xs-center pa-5">
                        <v-icon size="80" color="grey lighten-1" class="mb-3">shopping_basket</v-icon>
                        <h3 class="grey--text mb-2">No Products Found</h3>
                        <p class="grey--text body-1">Try adjusting your filters or search with different keywords.</p>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4" style="background: white;">
                    <div v-if="selectedProduct" class="body-2 grey--text">
                        <v-icon small color="teal darken-2" class="mr-1">check_circle</v-icon>
                        Selected: <strong>{{ selectedProduct.name | truncate(40, '...') }}</strong>
                    </div>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="teal darken-2"
                        dark
                        @click="confirmProductSelection"
                        :disabled="!selectedProduct"
                        large
                        class="px-6 elevation-4"
                        style="border-radius: 24px; text-transform: none; font-weight: bold;"
                    >
                        <v-icon left>arrow_forward</v-icon>
                        Create Savings Campaign
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                page: 1,
                campaigns: [],
                titleColor: 'teal--text',

                // Dialog produits
                productSelectionDialog: false,
                loadingProducts: false,
                dialogProducts: [],
                selectedProduct: null,
                dialogProductCategory: '',
                productCategories: [],
                dialogSearch: '',

                // Données d'éligibilité pour les campagnes marketplace
                eligibilityData: {},
                loadingEligibility: {},

                // Stockage séparé des informations de livraison CampaignDelivery
                campaignDeliveries: {},
                loadingDeliveries: {},
            }
        },

        computed: {
            // Séparer les campagnes completed en new/old system
            newSystemCampaigns() {
                return this.campaigns.filter(item => item.system_type === 'new');
            },
            oldSystemCampaigns() {
                return this.campaigns.filter(item => item.system_type === 'old');
            },

            // Filtrer les campagnes actives marketplace
            marketplaceActiveCampaigns() {
                return this.campaigns.filter(campaign => {
                    return campaign.market_item === true &&
                           campaign.market_item_id &&
                           campaign.market_item_id !== '0' &&
                           campaign.market_item_id !== '';
                });
            },

            // Campagnes actives non-marketplace
            nonMarketplaceActiveCampaigns() {
                return this.campaigns.filter(campaign => {
                    return campaign.market_item !== true ||
                           !campaign.market_item_id ||
                           campaign.market_item_id === '0' ||
                           campaign.market_item_id === '';
                });
            }
        },

        filters: {
            truncate(text, length, suffix) {
                if (!text) return ''
                const plainText = text.replace(/<[^>]*>/g, '')
                if (plainText.length > length) {
                    return plainText.substring(0, length) + suffix
                } else {
                    return plainText
                }
            }
        },

        methods: {
            // Méthode pour vérifier les livraisons CampaignDelivery
            async checkCampaignDelivery(campaignId) {
                if (this.$route.params.category !== 'active') {
                    return; // Seulement pour les campagnes actives
                }

                this.$set(this.loadingDeliveries, campaignId, true);

                try {
                    const response = await axios.get(
                        `/api/v1/market_place/campaigns/${campaignId}/check-delivery/`
                    );

                    if (response.data.has_delivery) {
                        this.$set(this.campaignDeliveries, campaignId, {
                            has_delivery: true,
                            delivery_date: response.data.delivery_date,
                            amount_at_delivery: response.data.amount_at_delivery,
                            percentage_at_delivery: response.data.percentage_at_delivery,
                            status: response.data.status
                        });
                    } else {
                        this.$set(this.campaignDeliveries, campaignId, {
                            has_delivery: false
                        });
                    }
                } catch (error) {
                    console.error('Error checking campaign delivery:', error);
                    // En cas d'erreur, marquer comme non livré
                    this.$set(this.campaignDeliveries, campaignId, {
                        has_delivery: false,
                        error: 'Unable to check delivery status'
                    });
                } finally {
                    this.$set(this.loadingDeliveries, campaignId, false);
                }
            },

            // Méthode pour déterminer si les boutons chat doivent être affichés
            shouldShowChatButtons(campaign) {
                // Pour les campagnes completed, on affiche les boutons chat normalement
                if (this.$route.params.category === 'completed') {
                    return campaign.completed_status === 'pending' &&
                           (!campaign.delivered || campaign.saved_amount < campaign.target_amount);
                }

                // Pour les campagnes actives marketplace
                if (this.$route.params.category === 'active' &&
                    campaign.market_item === true &&
                    campaign.market_item_id &&
                    campaign.market_item_id !== '0') {

                    const eligibility = this.eligibilityData[campaign.id];
                    const delivery = this.campaignDeliveries[campaign.id];

                    // Vérifier si la campagne a été livrée (via eligibility ou CampaignDelivery)
                    const hasBeenDelivered = (eligibility && eligibility.has_delivery) ||
                                            (delivery && delivery.has_delivery);

                    // Si pas encore chargé, ne pas afficher
                    if (!eligibility) {
                        return false;
                    }

                    // Si compte non éligible (standard) : ne pas afficher les boutons chat
                    if (!eligibility.has_special_status) {
                        return false;
                    }

                    // Si compte éligible ET campagne non livrée : afficher les boutons chat seulement à partir de 50%
                    if (eligibility.has_special_status && !hasBeenDelivered) {
                        const percentage = parseFloat(campaign.percentage_completed.replace('%', ''));
                        return percentage >= 50 && campaign.saved_amount < campaign.target_amount;
                    }
                }

                return false;
            },

            // NOUVELLES MÉTHODES POUR WHATSAPP ET CHAT AVEC LE FORMAT DEMANDÉ
            openWhatsApp(item) {
                const phoneNumber = '237656223451'
                const message = encodeURIComponent(
                    `Hello PettyCash,\n\n` +
                    `*Campaign/Order ID:* ${item.id}\n` +
                    `*Campaign Name:* ${item.name}\n` +
                    `*Amount Saved:* ${item.saved_amount.toLocaleString()} FCFA\n` +
                    `*Target Amount:* ${item.target_amount ? item.target_amount.toLocaleString() + ' FCFA' : 'N/A'}\n` +
                    `*Progress:* ${item.percentage_completed}\n\n` +
                    `I need assistance with this campaign. Thank you!`
                )
                window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank')
            },

            openPettyCashChat(item) {
                this.$root.$emit('open-chatbot', {
                    orderId: item.id,
                    autoMessage: `Hello, I need assistance with my campaign "${item.name}".\n\n` +
                                 `- Campaign ID: ${item.id}\n` +
                                 `- Item ID: ${item.market_item_id || 'N/A'}\n` +
                                 `- Amount: ${item.saved_amount.toLocaleString()} FCFA\n` +
                                 `- Progress: ${item.percentage_completed}\n\n` +
                                 `Can you help me?`
                })
            },


              async checkCampaignEligibility(campaignId) {
                  this.$set(this.loadingEligibility, campaignId, true)

                  try {
                      const response = await axios.get(
                          `/api/v1/market_place/campaigns/${campaignId}/check-eligibility/`
                      )

                      // ✅ Vérifier si le backend a retourné une erreur de barème
                      if (response.data.error) {
                          this.$set(this.eligibilityData, campaignId, {
                              error: true,
                              error_message: response.data.message || response.data.details,
                              is_eligible: false,
                              has_special_status: false,
                              user_credit_points: 0,
                              required_credit: 0,
                              bracket_found: false
                          })
                      } else {
                          // Stocker les données d'éligibilité normales
                          this.$set(this.eligibilityData, campaignId, response.data)

                          // Pour les campagnes actives, vérifier aussi CampaignDelivery
                          if (this.$route.params.category === 'active' && !response.data.has_delivery) {
                              await this.checkCampaignDelivery(campaignId);
                          }
                      }
                  } catch (error) {
                      console.error('Error checking eligibility:', error)
                      // Gestion d'erreur réseau
                      const campaign = this.campaigns.find(c => c.id === campaignId)
                      if (campaign) {
                          this.$set(this.eligibilityData, campaignId, {
                              error: true,
                              error_message: "Network error - unable to check eligibility",
                              is_eligible: false,
                              has_special_status: false,
                              user_credit_points: 0,
                              required_credit: 0,
                              bracket_found: false
                          })
                      }
                  } finally {
                      this.$set(this.loadingEligibility, campaignId, false)
                  }
              },

            requestDelivery(campaign) {
                this.$root.$emit('open-dialog', {
                    title: 'Request Delivery',
                    message: `Would you like to request delivery for "${campaign.name}"? We'll open WhatsApp so you can send your request to our support team.`,
                    type: 'info',
                    actions: [
                        {
                            text: 'Cancel',
                            color: 'grey'
                        },
                        {
                            text: 'Open WhatsApp',
                            color: '#25D366',
                            callback: () => {
                                this.openDeliveryRequestWhatsApp(campaign)
                            }
                        }
                    ]
                })
            },

            openDeliveryRequestWhatsApp(campaign) {
                const phoneNumber = '237656223451'
                const message = encodeURIComponent(
                    `🔔 *DELIVERY REQUEST*\n\n` +
                    `*Campaign:* ${campaign.name}\n` +
                    `*Campaign ID:* ${campaign.id}\n` +
                    `*Item ID:* ${campaign.market_item_id}\n` +
                    `*Client:* ${this.$store.state.user.username}\n` +
                    `*Amount Saved:* ${campaign.saved_amount.toLocaleString()} FCFA\n` +
                    `*Target:* ${campaign.target_amount.toLocaleString()} FCFA\n` +
                    `*Progress:* ${campaign.percentage_completed}\n\n` +
                    `I would like to request delivery of my item as I have reached the required 50% and have sufficient credit. Please process my delivery request.`
                )

                window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank', 'noopener,noreferrer')

                this.$store.commit('setSnackBarMessage', '✅ Opening WhatsApp to submit delivery request!')
                this.$store.commit('setSnackBarColor', 'success')
                this.$store.commit('activateSnackBar', true)
            },

            formatDate(dateString) {
                if (!dateString) return 'N/A'
                const date = new Date(dateString)
                return date.toLocaleDateString('fr-FR', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })
            },

            getCleanDescription(description, maxLength) {
                if (!description) return ''
                const cleanText = description.replace(/<[^>]*>/g, '').trim()
                if (cleanText.length > maxLength) {
                    return cleanText.substring(0, maxLength) + '...'
                }
                return cleanText
            },

            isVideo(url) {
                if (!url) return false
                const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.mkv']
                const lowerUrl = url.toLowerCase()
                return videoExtensions.some(ext => lowerUrl.includes(ext))
            },

            completeActiveCampaignMsg(){
                this.$store.commit('setSnackBarMessage', "Your active campaigns have reached the maximum limit of 2, please complete them first.")
                this.$store.commit('setSnackBarColor', "red darken-4")
                this.$store.commit('activateSnackBar', true)
            },

            goToRoute(routeName) {
                this.$router.push({ name: routeName });
            },

            async openProductSelectionDialog() {
                this.productSelectionDialog = true
                this.selectedProduct = null
                this.dialogSearch = ''
                await this.loadProductCategories()
                await this.getDialogProducts()
            },

            closeProductDialog() {
                this.productSelectionDialog = false
                this.selectedProduct = null
            },

            async loadProductCategories() {
                try {
                    const response = await axios.get('/api/v1/market_place/get/products/categories/')
                    this.productCategories = response.data
                    if (this.productCategories.length > 0) {
                        this.dialogProductCategory = this.productCategories[0].id
                    }
                } catch (error) {
                    console.error('Error loading categories:', error)
                }
            },

            async getDialogProducts() {
                this.loadingProducts = true
                try {
                    const response = await axios.get(
                        `/api/v1/market_place/get/products/${this.dialogProductCategory}/all/info/`
                    )
                    this.dialogProducts = response.data
                } catch (error) {
                    console.error('Error loading products:', error)
                    this.$store.commit('setSnackBarMessage', 'Error loading products')
                    this.$store.commit('setSnackBarColor', 'red darken-4')
                    this.$store.commit('activateSnackBar', true)
                } finally {
                    this.loadingProducts = false
                }
            },

            async searchDialogProducts() {
                if (!this.dialogSearch || this.dialogSearch.trim() === '') {
                    await this.getDialogProducts()
                    return
                }

                this.loadingProducts = true
                try {
                    const response = await axios.get(
                        `/api/v1/market_place/get/products/${this.dialogProductCategory}/all/${this.dialogSearch}/info/`
                    )
                    this.dialogProducts = response.data
                } catch (error) {
                    console.error('Error searching products:', error)
                    this.$store.commit('setSnackBarMessage', 'Error searching products')
                    this.$store.commit('setSnackBarColor', 'red darken-4')
                    this.$store.commit('activateSnackBar', true)
                } finally {
                    this.loadingProducts = false
                }
            },

            selectProduct(product) {
                this.selectedProduct = product
                console.log('Product selected:', product)
            },

            confirmProductSelection() {
                if (!this.selectedProduct) {
                    this.$store.commit('setSnackBarMessage', 'Please select a product')
                    this.$store.commit('setSnackBarColor', 'orange darken-2')
                    this.$store.commit('activateSnackBar', true)
                    return
                }

                this.$store.commit('setSaveItem', this.selectedProduct.id)
                this.productSelectionDialog = false
                this.$router.push('/market_place/campaign/create/new_campaign')
            },

            async getCampaigns(){
                this.$store.commit('setIsLoading', true)

                const campaign_category = this.$route.params.category

                if (campaign_category === 'completed') {
                    await axios
                        .get('/api/v1/market_place/user/completed_campaigns/')
                        .then(response => {
                            this.campaigns = response.data
                            this.titleColor = 'blue--text'
                        })
                        .catch(error => {
                            if (error.response){
                                console.log(error.response)
                                this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }else{
                                this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }
                        })
                } else {
                    await axios
                        .get('/api/v1/market_place/get/user/campaigns/'+campaign_category+'/')
                        .then(response => {
                            this.campaigns = response.data
                            if (campaign_category === 'all'){
                                this.titleColor = 'grey--text'
                            }
                            else if (campaign_category === 'active'){
                                this.titleColor = 'teal--text'
                                this.$store.commit('setLengthActiveCampaigns2', this.campaigns.length)

                                // Vérifier l'éligibilité pour chaque campagne marketplace active
                                setTimeout(() => {
                                    this.campaigns.forEach(campaign => {
                                        if (campaign.market_item === true && campaign.market_item_id && campaign.market_item_id !== '0') {
                                            this.checkCampaignEligibility(campaign.id)
                                        }
                                    })
                                }, 500)
                            }
                            else if (campaign_category === 'interrupted'){
                                this.titleColor = 'red--text'
                            }
                            else if (campaign_category === 'completed'){
                                this.titleColor = 'blue--text'
                            }
                        })
                        .catch(error => {
                            if (error.response){
                                console.log(error.response)
                                this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }else{
                                this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }
                        })
                }
                this.$store.commit('setIsLoading', false)
            },
        },

        watch: {
            '$route': function(to, from) {
                this.getCampaigns();
            }
        },

        mounted(){
            this.getCampaigns();
            const campaign_category = this.$route.params.category
            document.title = "PettyCash | "+campaign_category+" user's campaigns"
            sessionStorage.setItem('url', window.location.href);
            this.$store.commit('setCloseURL', "/savings")
            this.$store.commit('setSaveItem', "")
        },
    }
</script>

<style scoped>
/* Styles identiques */
.transfer-btn {
    min-width: 160px !important;
    border-radius: 24px !important;
    background: linear-gradient(135deg, #7b1fa2 0%, #4a0072 100%) !important;
    box-shadow: 0 4px 12px rgba(123, 31, 162, 0.3) !important;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    text-transform: none;
    height: 36px !important;
}

.transfer-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(123, 31, 162, 0.4) !important;
}

.menu-card {
    border-radius: 14px !important;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px);
    border: 1px solid #e0e0e0;
}

.menu-list {
    padding: 6px 0 !important;
}

.menu-item {
    padding: 10px 16px !important;
    transition: all 0.25s ease;
    cursor: pointer;
}

.menu-item:hover {
    background-color: #f5f5f5 !important;
    transform: translateX(3px);
}

.send-item:hover {
    background: linear-gradient(to right, #e8f5e9, #ffffff) !important;
}

.receive-item:hover {
    background: linear-gradient(to right, #e3f2fd, #ffffff) !important;
}

.menu-divider {
    background-color: #e0e0e0 !important;
    margin: 4px 0 !important;
}

.selected-product-card {
    border: 4px solid #00897B !important;
    background: linear-gradient(to bottom, #e8f5f3, #ffffff) !important;
    box-shadow: 0 8px 24px rgba(0, 137, 123, 0.3) !important;
    transform: scale(1.02);
}

.media-container {
    width: 100% !important;
}

.v-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(0,0,0,0.15) !important;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes scaleIn {
    from {
        transform: scale(0.5);
    }
    to {
        transform: scale(1);
    }
}

blink {
    -webkit-animation: 4s linear infinite condemned_blink_effect;
    animation: 4s linear infinite condemned_blink_effect;
}

@-webkit-keyframes condemned_blink_effect {
    0% { visibility: hidden; }
    50% { visibility: hidden; }
    100% { visibility: visible; }
}

@keyframes condemned_blink_effect {
    0% { visibility: hidden; }
    50% { visibility: hidden; }
    100% { visibility: visible; }
}

.button-group {
    gap: 8px;
}

/* Styles pour les boutons d'action */
.action-btn {
    min-width: 120px !important;
    border-radius: 20px !important;
    font-size: 11px !important;
    height: 28px !important;
}

.whatsapp-btn {
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%) !important;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3) !important;
}

.chat-btn {
    background: linear-gradient(135deg, #00897B 0%, #00695C 100%) !important;
    box-shadow: 0 2px 8px rgba(0, 137, 123, 0.3) !important;
}

.delivery-icon-btn {
    border-radius: 50% !important;
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3) !important;
}

.action-btn:hover, .delivery-icon-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2) !important;
}

/* Styles pour les nouvelles sections */
.marketplace-campaign-card {
    transition: all 0.3s ease;
    border-left: 4px solid #00897B !important;
}

.marketplace-campaign-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 137, 123, 0.2) !important;
}

/* Style pour les badges d'éligibilité */
.eligibility-badge {
    padding: 4px 8px;
    background-color: rgba(76, 175, 80, 0.1);
    border-radius: 4px;
    border-left: 3px solid #4CAF50;
    cursor: help;
}
</style>
